// Short, sortable, collision-resistant ids for custom items and recipe records.
let counter = 0;
const enc = 'abcdefghijklmnopqrstuvwxyz0123456789';

export function shortId(prefix = ''): string {
  counter = (counter + 1) % 36;
  const time = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 8);
  const seq = enc[counter];
  return `${prefix}${time}${seq}${rand}`;
}

export function customItemId(): string {
  return `custom:${shortId()}`;
}

export function recipeRecordId(): string {
  return `recipe:${shortId()}`;
}
